module.exports = __webpack_public_path__ + "static/media/logo.fbefff43.svg";